<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Channels</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          data-animation="false"
          title="Channels available for apps considered as aggregators or providers of 'skinny bundles'">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-0">
    <div class="col-lg-12 px-0">
      <app-ctv-channels [data]="data" [isFreemium]="isFreemium"></app-ctv-channels>
    </div>
  </div>
</div>
